// Do proper analytics tracking

import type { CampaignQuestState } from "@/components/QuestsV2/types";
import { type Action, useAnalytics } from "@/context/AnalyticsProvider";
import type { GetGameDetailsAPIResponse } from "./types";

const useGameDetailsAnalytics = () => {
  const { trackV3 } = useAnalytics();

  const trackQuestEvent = (
    action: Action,
    location: string,
    quest: CampaignQuestState,
    extras?: Record<string, unknown>,
  ) => {
    if (!trackV3) return;
    trackV3({
      object: "Quest",
      action: action,
      extras: {
        questId: quest.externalId,
        questName: quest.name,
        questType: quest.type,
        gameId: quest.gameId,
        section: location,
        ...(extras ?? {}),
      },
    });
  };

  const trackGameEvent = (
    action: Action,
    location: string,
    game: GetGameDetailsAPIResponse,
    extras?: Record<string, unknown>,
  ) => {
    if (!trackV3) return;
    trackV3({
      object: "Game",
      action: action,
      extras: {
        gameId: game.game_id,
        gameName: game.name,
        section: location,
        ...(extras ?? {}),
      },
    });
  };

  return {
    trackQuestEvent,
    trackGameEvent,
  };
};

export default useGameDetailsAnalytics;
